import React from 'react';
import '../css/style.scss';
import _ from 'lodash';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../css/visitorCheckout.scss';
import HomePageLogo from '../../../../../assets/images/vms/bslogo.png';
import CheckoutBuilding from '../../../../../assets/svg/vms/1024x768_checkout_building.svg';

const Page1 = props => {
  const { setFieldValue, phoneNumber, errors, translations, setGoTo, config } = props;
  return (
    <>
      <div className="co-wrap">
        <img className="co-wrap__girl" src={CheckoutBuilding} alt="homepage-logo" />
        <img className="co-wrap__boy" src={CheckoutBuilding} alt="homepage-logo" />
        <div className="co-wrap__head-logo">
          <img src={HomePageLogo} alt="homepage-logo" />
        </div>
        <div className="co-wrap__form">
          <div className="co-wrap__head">
            <div className="co-wrap__head-title">{_.get(translations, 'checkoutTitle')}</div>
            <div className="co-wrap__head-description">{_.get(translations, 'checkoutSubtitle')}</div>
          </div>
          <div className="co-form">
            <div className="co-form__row">
              <label htmlFor="phoneNumber" className="co-form__row--label">
                {_.get(translations, 'phoneNumber')}
              </label>
              <PhoneInput
                international
                defaultCountry="GB"
                countryCallingCodeEditable={false}
                placeholder={_.get(translations, 'enterYourPhoneNumber')}
                value={phoneNumber}
                onChange={value => setFieldValue({ phoneNumber: value })}
                autoComplete="new-password"
              />
              {_.get(errors, 'phoneNumber') ? (
                <p className="co-error">{_.get(translations, `${errors.phoneNumber}`, 'Wrong phone number')}</p>
              ) : null}
            </div>

            <div className="co-form__buttons">
              <button type="button" className="co-form__buttons-previous" onClick={() => setGoTo('previous')}>
                {_.get(config, 'page1.btn_prev.text', '')}
              </button>
              <button type="button" className="co-form__buttons-next" onClick={() => setGoTo('next')}>
                {_.get(config, 'page1.btn_next.text', '')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="co-footer">{_.get(translations, 'allRightsReserved')}</div>
    </>
  );
};

Page1.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.any,
  translations: PropTypes.shape(),
  setGoTo: PropTypes.func.isRequired,
  config: PropTypes.shape(),
};

Page1.defaultProps = {
  phoneNumber: '',
  errors: [],
  translations: {},
  config: {},
};

export default Page1;
